import HttpService from './HttpService';

export default HttpService;
